import creditCard from './images/credit-card-payment-colored.png'
import logoPix from './images/logo_pix.png'
import masterCard from './images/mastercard.png'
import payColor from './images/pay-colored.png'
import payTerminal from './images/payment-terminal-colored.png'
import pixAgendei from './images/pix-agendei.png'

export { default as Logo } from './images/LogoAgendeiQuadras.png'
export { default as login1 } from './images/missao-min.png'
export { default as recPass } from './images/img-rec-pass.png'
export { default as confPassLogo } from './images/img-conf-pass.png'
export { default as LogoAgendei } from './images/LogoAgendeiQuadras.png'
export { default as mapLocation } from './images/map-location.png'
export { default as voceSabia } from './images/voceSabia-min.png'
export { default as segSearch } from './images/seg-search.png'
export { default as semFoto } from './images/semFoto.jpg'
export { default as notAgend } from './images/not-agends.png'
export { default as pixAgendei } from './images/pix-agendei.png'
export { default as notConfig } from './images/not-configurated.png'
export { default as error404 } from './images/missed-chances.gif'
export { default as newAppLogo } from './images/new_logo_agendeiquadras.png'
export { default as CalClock } from './svgs/calendar-clock.svg'
export { default as BeachTenis } from './images/beachTennis.png'
export { default as Futebol } from './images/campeonatos-de-futebol.png'

export { default as accountAnimated } from './lotties/account-animated.json'
export { default as agendeiAnimated } from './lotties/agendeiv3.json'
export { default as atomsAnimated } from './lotties/atoms-animated.json'
export { default as bookingFailedAnimated } from './lotties/booking-failed-animated.json'
export { default as bookingSuccessAnimated } from './lotties/booking-success-animated.json'
export { default as bubblesAnimated } from './lotties/bubbles-animated.json'
export { default as checkAnimated } from './lotties/check-animated.json'
export { default as completedAnimated } from './lotties/completed-animated.json'
export { default as failedAnimated } from './lotties/failed-animated.json'
export { default as loadingAnimated } from './lotties/loading-animated.json'
export { default as loginAnimated } from './lotties/login-animated.json'
export { default as loginWaveAnimated } from './lotties/login-wave-animated.json'
export { default as notificationPermissionsAnimated } from './lotties/notification-permissions-animated.json'
export { default as playingAnimated } from './lotties/playing-animated.json'
export { default as splashAnimated } from './lotties/splash-animated.json'
export { default as sportsAnimated } from './lotties/sports-animated.json'
export { default as starAnimated } from './lotties/star-animated.json'
export { default as waveAnimated } from './lotties/waves-animated.json'
export { default as loadingBasket } from './lotties/loading-basket.json'

export { default as JostMedium } from './fonts/Jost-Medium.ttf'
export { default as JostBold } from './fonts/Jost-Bold.ttf'
export { default as JostLight } from './fonts/Jost-Light.ttf'
export { default as BalooBhaina } from './fonts/BalooBhaina-Regular.ttf'

const iconsPayment = {
  creditCard,
  logoPix,
  masterCard,
  payColor,
  payTerminal,
  pixAgendei,
}

export { iconsPayment }
